// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3H9ip","footer":"ModalFilter_footer__2usZa"};